import React from 'react'
import AboutNavBar from '../components/AboutNavBar'
// import BlockChainServiceDetails from '../components/BlockChainServiceDetails'
// import BlockChainServicesContent from '../components/BlockChainServicesContent'
import Blog2Details from '../components/Blog2Details'
import Footer from '../components/Footer'
import RenderLinks from '../components/RenderLinks'

function Blogs() {
  return (
    <div>
      <RenderLinks/>
      <AboutNavBar/>
      <Blog2Details/>
      {/* <BlockChainServiceDetails/> */}
      {/* <BlockChainServicesContent/> */}
      <Footer/>
    </div>
  )
}

export default Blogs
